import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  VolumeContainer,
  VolumeIconContainer,
  Track,
  Thumb,
  VolumeRange,
  VolumeSlider,
  sliderWidth,
} from './styles';

import FullSoundIcon from './FullSoundIcon';
import LowSoundIcon from './LowSoundIcon';
import NoSoundIcon from './NoSoundIcon';
import { usePlayer } from '../../../PlayerContext';

function Volume({ mini, toggleProgressBar, displayProgressBarTimeoutRef }) {
  const player = usePlayer();
  const volume = useSelector(state => state.playback.volume);

  const [hovered, setHovered] = useState(false);

  const onVolumeChange = (e) => {
    player.changeVolume(parseFloat(e.target.value, 10));
  };

  const toggleMute = () => player.toggleMute();

  const renderVolumeIcon = () => {
    if (volume === 0) {
      return (
        <NoSoundIcon onClick={toggleMute} />
      );
    }

    if (volume <= 0.5) {
      return (
        <LowSoundIcon onClick={toggleMute} />
      );
    }

    return (
      <FullSoundIcon onClick={toggleMute} />
    );
  };

  const sliderRef = React.createRef();

  const hoveredStateTimeoutRef = useRef(null);
  const onMouseEnter = () => {
    clearTimeout(displayProgressBarTimeoutRef.current);
    clearTimeout(hoveredStateTimeoutRef.current);
    setHovered(true);
    toggleProgressBar(false);
  };
  const onMouseLeave = () => {
    displayProgressBarTimeoutRef.current = setTimeout(() => {
      toggleProgressBar(true);
    }, 200);
    hoveredStateTimeoutRef.current = setTimeout(() => {
      setHovered(false);
    }, 200);
  };

  // The volume slider is quite a hack. The real slider is a range input with
  // opacity 0 and then the UI is reimplemented on top of the invisible control.
  // The reason is that <input type=range /> can't be styled the way we want it
  // to look. These magic numbers below is needed to keep the so called thumb
  // between the beginning and end of the hidden slider in 'all' browsers.
  const width = sliderRef.current ? sliderRef.current.offsetWidth : sliderWidth;
  const thumbLeft = (volume * width) - (volume * 30);

  return (
    <VolumeContainer
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      mini={mini}
    >
      <VolumeIconContainer>
        {renderVolumeIcon()}
      </VolumeIconContainer>
      <VolumeSlider hovered={hovered}>
        <Track barWidth={sliderWidth - 20} />
        <Track barWidth={thumbLeft} brand />
        <Thumb left={thumbLeft} />
        <VolumeRange
          ref={sliderRef}
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={onVolumeChange}
        />
      </VolumeSlider>
    </VolumeContainer>
  );
}

Volume.propTypes = {
  mini: PropTypes.bool,
  toggleProgressBar: PropTypes.func,
  displayProgressBarTimeoutRef: PropTypes.shape({ current: PropTypes.number }),
};

export default React.memo(Volume);
